// Lib
import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

// Components
import PopupPanel from '../../../../../components/popupPanel/PopupPanel';
import QuickNotesScrollableList from '../../../../quickNotes/QuickNotesScrollableList';
import PopupBoardSectionFocusManager from '../../../../../components/popupPanel/PopupBoardSectionFocusManager';
import QuickNotesContextMenuManager from './QuickNotesContextMenuManager';
import PopupList from '../../../../../components/popupPanel/types/PopupList';
import PoiBoardSectionContext from '../../../../../components/pointsOfInterest/PoiBoardSectionContext';

// Utils
import { getCurrentUserId } from '../../../../../user/currentUserSelector';
import { userCheckedQuickNotes } from '../../../../../user/currentUserActions';

// Constants
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';
import { WORKSPACE_SECTIONS } from '../../../../workspaceConstants';

// Styles
import './QuickNotesPopup.scss';

type Props = {
    quickNotesRootId: string;
    quickNotesChildIds: string[];
    gridSize: number;
    permissions: number;
};

const QuickNotesPopupContent = (props: Props) => {
    const { quickNotesRootId, quickNotesChildIds, gridSize } = props;

    const currentUserId = useSelector(getCurrentUserId);

    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(userCheckedQuickNotes({ userId: currentUserId }));
        };
    }, []);

    return (
        <PopupBoardSectionFocusManager
            ignoredClicksSelector=".ContextMenu"
            section={WORKSPACE_SECTIONS.QUICK_NOTES}
            childElementIds={quickNotesChildIds}
        >
            <QuickNotesContextMenuManager quickNotesRootId={quickNotesRootId} gridSize={gridSize} isEditable={true}>
                <PopupList title={<h2 className="quick-notes-popup-title">From your phone</h2>}>
                    <PoiBoardSectionContext.Provider value={WORKSPACE_SECTIONS.QUICK_NOTES}>
                        <QuickNotesScrollableList {...props} />
                    </PoiBoardSectionContext.Provider>
                </PopupList>
            </QuickNotesContextMenuManager>
        </PopupBoardSectionFocusManager>
    );
};

const QuickNotesPopup = (props: Props) => {
    const { quickNotesChildIds } = props;

    return (
        <PopupPanel
            {...props}
            popupId={PopupIds.QUICK_NOTES}
            ignoredClicksSelector=".SelectionToolList,.Breadcrumb,.Board,.Alias"
            className={classNames('QuickNotesPopup', { empty: quickNotesChildIds.length === 0 })}
            closeOnMouseUp
        >
            <QuickNotesPopupContent {...props} />
        </PopupPanel>
    );
};

export default QuickNotesPopup;
